import React, { useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
function ChatContacts({ handleContactClick, data }) {
  const [openStores, setOpenStores] = useState({});

  if (!data || !Array.isArray(data)) {
    return <p>No contacts available</p>;
  }

  const handleShowContacts = (index) => {
    setOpenStores((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <div>
      {data.map((store, index) => (
        <div key={store?.id || index} className="mb-3 ">
          <h2
            className="font-bold text-xl cursor-pointer"
            style={{ color: store?.color_code }}
            onClick={() => handleShowContacts(index)}
          >
            {store?.store_name}
            {openStores[index] ? (
              <KeyboardArrowUpIcon />
            ) : (
              <KeyboardArrowDownIcon />
            )}
          </h2>

          {openStores[index] && (
            <ul>
              {store?.users.map((contact) => (
                <li
                  key={contact?.id}
                  className="px-1 hover:bg-gray-200 cursor-pointer rounded"
                  onClick={() =>
                    handleContactClick(contact?.id, contact?.firstname)
                  }
                >
                  <h2 className="flex gap-2 items-center justify-between">
                    {contact?.firstname}
                    {contact?.messages.filter(
                      (item) =>
                        item.role === "receiver" && Number(item?.is_read) === 0
                    ).length > 0 && (
                      <span className="text-[8px] p-1 w-3 h-3 bg-green-500 rounded-full flex justify-center items-center text-white">
                        {
                          contact?.messages.filter(
                            (item) =>
                              item.role === "receiver" &&
                              Number(item?.is_read) === 0
                          ).length
                        }
                      </span>
                    )}
                  </h2>
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
}

export default ChatContacts;
